export const setDesignation = (grgLotNumber, designation) =>
  `${grgLotNumber} ${designation ?? ''}`.trimEnd();
